/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type subsidy_RecordSubsidyReportDecisionRequest = {
    comment?: string;
    /**
     * DecisionNumber is required for an approval (max 16 characters, the Kollab EBB number).
     */
    decision_number?: string;
    /**
     * DecisionOn (YYYY-MM-DD) defaults to today in the organisation's time zone; never in the future.
     */
    decision_on?: string;
    outcome: subsidy_RecordSubsidyReportDecisionRequest.outcome;
};
export namespace subsidy_RecordSubsidyReportDecisionRequest {
    export enum outcome {
        APPROVED = 'approved',
        REJECTED = 'rejected',
    }
}

